import React from 'react'
import { Grid } from '@mui/material'
import useInsuranceQuoteBlock from './useInsuranceQuoteBlock'
import { DataGrid } from '@mui/x-data-grid'
import { formatCents } from '../../../../../../utils/currency-formatter'
const columns = [
  {
    field: 'quoteId',
    headerName: 'Quote Id',
    flex: 0.75,
  },
  {
    field: 'limits',
    headerName: 'Limits',
    flex: 0.5,
  },
  {
    field: 'deductible',
    headerName: 'Deductible',
    flex: 0.5,
    renderCell: (params) => {
      return formatCents(params.row.deductible)
    },
  },
  {
    field: 'monthlyRate',
    headerName: 'Monthly Rate',
    flex: 0.5,
    renderCell: (params) => {
      return formatCents(params.row.monthlyRate)
    },
  },
  {
    field: 'mileageRate',
    headerName: 'Mileage Rate',
    flex: 0.5,
    renderCell: (params) => {
      return formatCents(params.row.mileageRate)
    },
  },
]
const quoteColumns = [
  {
    field: 'quoteId',
    headerName: 'Quote Id',
    flex: 0.75,
  },
  {
    field: 'limits',
    headerName: 'Limits',
    flex: 1,
  },
  {
    field: 'deductible',
    headerName: 'Deductible',
    flex: 0.5,
    renderCell: (params) => {
      return formatCents(params.row.deductible)
    },
  },
  {
    field: 'monthlyRate',
    headerName: 'Monthly Rate',
    flex: 0.5,
    renderCell: (params) => {
      return formatCents(params.row.monthlyRate)
    },
  },
  {
    field: 'mileageRate',
    headerName: 'Mileage Rate',
    flex: 0.5,
    renderCell: (params) => {
      return formatCents(params.row.mileageRate)
    },
  },
  {
    field: 'state',
    headerName: 'State',
    flex: 0.5,
  },
  {
    field: 'zip',
    headerName: 'Zip',
    flex: 0.5,
  },
  {
    field: 'vehicleMake',
    headerName: 'Make',
    flex: 0.5,
  },
  {
    field: 'vehicleModel',
    headerName: 'Model',
    flex: 0.5,
  },
  {
    field: 'vehicleVin',
    headerName: 'VIN',
    flex: 0.5,
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    flex: 0.75,
    renderCell: (params) => {
      return new Date(params.row.createdAt).toLocaleDateString()
    },
  },
]
const EMPTY_QUOTE = '00000000-0000-0000-0000-000000000000'
const InsuranceQuoteBlock = ({ subscriptionId, customerId }) => {
  const { useInsuranceQuote } = useInsuranceQuoteBlock()
  const { insuranceQuote } = useInsuranceQuote({ subscriptionId, customerId })

  return (
    <Grid container direction="column" spacing={6}>
      <Grid>
        {insuranceQuote?.quoteId && insuranceQuote?.quoteId !== EMPTY_QUOTE ? (
          <DataGrid
            autoHeight
            columns={columns}
            rows={insuranceQuote || []}
            getRowId={(row) => row.quoteId}
            disableColumnFilter
          />
        ) : (
          <LatestQuoteGroup subscriptionId={subscriptionId} />
        )}
      </Grid>
    </Grid>
  )
}
const LatestQuoteGroup = ({ subscriptionId }) => {
  const { useLatestQuoteGroup } = useInsuranceQuoteBlock()
  const { latestQuoteGroup } = useLatestQuoteGroup({
    subscriptionId,
  })

  return (
    <Grid container direction="column" spacing={6}>
      <Grid>
        {latestQuoteGroup?.length ? (
          <DataGrid
            autoHeight
            columns={quoteColumns}
            rows={latestQuoteGroup || []}
            getRowId={(row) => row.quoteId}
            // pageSize={6}
            disableColumnFilter
          />
        ) : (
          'Latest quote group not found'
        )}
      </Grid>
    </Grid>
  )
}
export default InsuranceQuoteBlock
